import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import '../styles/plastic.css'; // Assuming you are already using a custom CSS file
import Ac1 from '../assets/images/ac1.jpg';
import Ac2 from '../assets/images/ac2.jpg';
import Ac3 from '../assets/images/ac3.jpg';
import Ac4 from '../assets/images/ac4.jpg';
import Ac5 from '../assets/images/ac5.jpg';
import Ac6 from '../assets/images/ac6.jpg';

const Ac = () => {
  const [customStyle, setCustomStyle] = useState(false); // Track the style toggle

  const images = [
    Ac1,
    Ac2,
    Ac3,
    Ac4,
    Ac5,
    Ac6,
  ];

  // Toggle custom styling
  const switchStyle = () => {
    setCustomStyle(!customStyle);
  };

  return (
    < div >
      <section className="about-container"> <h1>AC IDU & ODU Assembly</h1>
      </section>
      <br/><br/>
    <div className="acer-container">
      {/* Gallery with hover animation */}
      <div className={`row ${customStyle ? "hover-effect-2" : "hover-effect-1"}`} id="gallery">
        {images.map((src, index) => (
          <div className="col-12 col-sm-6 col-lg-4 mb-4" key={index}>
            <img
              className="w-100 hover-img"
              src={src}
              alt={`Slide ${index + 1}`}
            />
          </div>
        ))}
      </div>
    </div>
    </div>
  );
};

export default Ac;
